import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import '../styles/Sector.css';
import logo from '../assets/sector2.png';
import centerImage from '../assets/logo.png'; // Replace with your actual image
import slide1 from '../assets/cs5.jpg';
import slide2 from '../assets/gst3.webp';
import slide3 from '../assets/cs6.jpg';
import slide4 from '../assets/mn5.jpeg';
import slide5 from '../assets/mn7.jpeg';


const slideImages = [
  { src: slide1, alt: 'Slide 1' },
  { src: slide2, alt: 'Slide 2' },
  { src: slide3, alt: 'Slide 3' },
  { src: slide4, alt: 'Slide 4' },
  { src: slide5, alt: 'Slide 5' },
];

const Sector = () => {
  const numSeats = slideImages.length;
  const angleIncrement = 360 / numSeats;

  const textRef = useRef(null);
  const wheelRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up-visible');
          observer.unobserve(entry.target); // Only once
        }
      });
    }, observerOptions);

    if (textRef.current) observer.observe(textRef.current);
    if (wheelRef.current) observer.observe(wheelRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-section" id="about">
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* ABOUT US */}
      </motion.h1>

      <motion.p
        className="intro-text"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
       Matrix Consultancy Services is one of the leading manpower recruitment consultancy in India, supplying manpower to different industries. We have excellent connections with consultancies and industries located overseas. We are managed by professionals, senior civil servants and technocrats to assure clients of the best service, and to satisfy the need for quality manpower
      </motion.p>

      <motion.div
        className="center-image"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <img src={centerImage} alt="Team working" />
      </motion.div>

      <div className="sector-layout">
        <div ref={textRef} className="sector-text fade-up-init">
          <h3>Website Design</h3>
          <ul>
            <li>We specialize in creating modern, responsive websites that reflect your brand’s identity and engage your audience. Whether you're a startup or an established business, our design team crafts visually stunning and user-friendly websites optimized for all devices. From layout to functionality, we ensure your website not only looks great but also delivers a smooth experience that drives results.</li>
            <li>Our hosting services provide the foundation your website needs to perform at its best.</li>
          </ul>

          <h3>Manpower Outsourcing</h3>
          <ul>
            <li>Our manpower outsourcing services are designed to help businesses stay agile and efficient. Whether you need temporary staffing, project-based teams, or long-term workforce solutions, we provide skilled professionals matched precisely to your requirements. With a strong focus on quality, compliance, and quick turnaround, we take the stress out of recruitment so you can focus on your core operations.</li>
            <li>We don’t just supply manpower — we deliver workforce solutions that align with your goals and culture. From initial screening to onboarding and performance monitoring, we manage every aspect to ensure a smooth integration with your team. With a broad talent pool across industries and 24/7 support, we help businesses scale smarter, reduce overhead costs, and maintain peak productivity.</li>
          </ul>

          <h3>Gst Registration</h3>
          <ul>
            <li>Getting your business GST-registered is a crucial step toward compliance and growth, and we make the process simple and stress-free. Our expert team handles all the paperwork, ensures proper documentation, and guides you through every step—so you can get your GST number quickly and without errors. Whether you're a startup, freelancer, or established business, we offer tailored solutions to meet your specific needs.</li>
            <li>Our service doesn't stop at registration. We provide ongoing support to ensure your GST compliance stays on track, including filing returns, managing notices, and offering expert tax advice when needed. With timely updates and reliable assistance, you can avoid penalties, stay focused on your business, and operate with full confidence under the GST regime.</li>
          </ul>
        </div>

        <div className="sector-sector-container fade-up-init" ref={wheelRef}>
          <div className="sector-logo-container">
            <img src={logo} alt="Center Logo" className="sector-center-logo" />
          </div>

          <div className="sector-ferris-wheel">
            {slideImages.map((image, index) => {
              const seatAngle = angleIncrement * index;
const wrapperStyle = {
  transform: `rotate(${seatAngle}deg) translateY(var(--sector-wheel-radius)) rotate(-${seatAngle}deg)`,
};

              return (
                <div
                  key={index}
                  className="sector-seat-wrapper"
                  style={wrapperStyle}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="sector-seat-image"
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sector;